import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-form-error-message',
    template: `
    <mat-error class="is-valid" [class.is-invalid]="form && form.invalid && form.touched">{{ errorMessage }}</mat-error>
  `,
    styles: ['mat-error { margin-top: 10px; margin-right: 15px; } .is-valid { display: none; } .is-invalid { display: block; }'],
    standalone: false
})
export class FormErrorMessageComponent implements OnInit, OnDestroy {
  private subscription: Subscription;

  @Input() public form: FormGroup;
  @Input() public label: string;
  @Input() public labelKey: string;
  public errorMessage: string;

  constructor(private translateService: TranslateService) {
    this.label = this.translateService.instant('Required input fields missing');
  }

  public ngOnInit(): void {
    this.subscription = this.form.statusChanges.pipe(startWith(null)).subscribe(() => {
      if (this.form.invalid) {
        if (this.labelKey) {
          this.label = this.translateService.instant(this.labelKey);
        }
        this.errorMessage = this.label;
      }
    });
  }

  public ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
